export default {
  TITLE: "Réservations de commandes spéciales",
  REMAINING_QUANTITY: "Quantite restante",
  DELETE_CONFIRMATION: "Supprimer cette réservation de commande spéciale ?",
  DELETED: "éservation de commande spéciale supprimée",
  NO_RESERVATIONS: "Aucune réservations de commande spéciale",
};
